import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Typography } from '~/components/common/Typography'
import { LoadingIcon } from '~/components/icons'

/**
 * Checkout Callback Page
 *
 * This page is opened in a new tab after Stripe checkout completes.
 * It communicates the result back to the opener tab via postMessage,
 * then auto-closes itself. The opener tab verifies the session and
 * shows a success modal.
 */
const CheckoutCallbackPage = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const status = searchParams.get('status')
    const sessionId = searchParams.get('session_id')

    // Communicate result back to parent window
    if (window.opener) {
      if (status === 'success' && sessionId) {
        window.opener.postMessage(
          {
            type: 'stripe-checkout-complete',
            sessionId
          },
          window.location.origin
        )
      } else if (status === 'canceled') {
        window.opener.postMessage(
          {
            type: 'stripe-checkout-canceled'
          },
          window.location.origin
        )
      }

      // Close the tab after a short delay to ensure message is sent
      setTimeout(() => {
        window.close()
      }, 500)
    } else {
      // If there's no opener (user navigated directly), redirect to home
      window.location.href = '/'
    }
  }, [searchParams])

  return (
    <div className='flex flex-col items-center justify-center min-h-screen gap-4 bg-gray-50'>
      <LoadingIcon />
      <Typography fontFamily='geist' fontSize='bodyMd' className='text-gray-600'>
        Processing payment...
      </Typography>
      <Typography fontFamily='geist' fontSize='bodySm' className='text-gray-500'>
        This window will close automatically.
      </Typography>
    </div>
  )
}

export default CheckoutCallbackPage
